import { createAction } from '@reduxjs/toolkit';

import { SetPhListnerAction, SetPrevEmail } from './ph.types';

export const setPhListnerAction = createAction<SetPhListnerAction>('ph/setPhListnerAction');
export const setPrevEmail = createAction<SetPrevEmail>('ph/setPrevEmail');
